import { createSlice } from '@reduxjs/toolkit'

export interface ImageGeneratorState {
  isOpen: boolean
}

const initialState: ImageGeneratorState = {
  isOpen: false,
}

export const imageGeneratorSlice = createSlice({
  name: 'imageGenerator',
  initialState,
  reducers: {
    openImageGenerator(state) {
      state.isOpen = true
    },
    closeImageGenerator(state) {
      state.isOpen = false
    },
  },
})

export const { openImageGenerator, closeImageGenerator } = imageGeneratorSlice.actions
